import { localStorage } from './storage'

// TODO: Remove the classic design once refresh is canonical.
/**
 * Which look the portal renders. `classic` is the long-standing design;
 * `refresh` swaps the theme tokens and renders the redesigned navigation, job
 * list and job details.
 *
 * Chosen per browser from Profile › General and read once at boot. Switching
 * reloads the page, so nothing needs to react to it at runtime.
 */
export type Design = 'classic' | 'refresh'

/**
 * Class on `<html>` that switches the theme tokens in `css/variables.css`.
 */
export const refreshClassName = 'portal-refresh'

const storageKey = 'Portal design'

function readDesign(): Design {
  return localStorage.getItem(storageKey) === 'refresh' ? 'refresh' : 'classic'
}

/**
 * The design this browser renders.
 */
export const design: Design = readDesign()

/**
 * Whether the refresh design is rendered.
 */
export const isRefreshDesign = design === 'refresh'

/**
 * Picks the classic or refresh variant of a value, such as an illustration.
 * Pass both `require`s inline so the bundler can resolve each path.
 */
export function byDesign<T>(classic: T, refresh: T): T {
  return isRefreshDesign ? refresh : classic
}

/**
 * Stores the design and reloads the page to apply it.
 *
 * @param next
 */
export function setDesign(next: Design) {
  localStorage.setItem(storageKey, next)
  window.location.reload()
}
